import { CenterAlignIcon, LeftAlignIcon, RightAlignIcon } from 'assets/icons/common'
import { AlignmentDropdown } from 'common/Prose/nodeViews/Image/components/AlignmentDropdown/AlignmentDropdown'
import { startCase } from 'lodash'
import { observer } from 'mobx-react-lite'
import { EditorView } from 'prosemirror-view'
import { ProseDropdownPrompt } from '../ProseDropdownPrompt/ProseDropdownPrompt'

export type NodeAlignmentButtonProps = {
  view: EditorView
  nodePos: number
  alignment: 'left' | 'right' | 'center'
  nodeAttrs: Record<string, any>
  isDisabled?: boolean
}

export const NodeAlignmentButton = observer(function LinkInlineFormatButton({
  view,
  nodePos,
  alignment,
  nodeAttrs,
  isDisabled = false,
}: NodeAlignmentButtonProps) {
  return (
    <ProseDropdownPrompt
      withChevron
      view={view}
      anchorChildren={
        <>
          {(() => {
            switch (alignment) {
              case 'left':
                return <LeftAlignIcon />
              case 'right':
                return <RightAlignIcon />
              case 'center':
              default:
                return <CenterAlignIcon />
            }
          })()}
          {startCase(alignment)}
        </>
      }
      label="Set alignment"
      placement="bottom-start"
      isDisabled={isDisabled}
      dropdownComponent={(close) => (
        <AlignmentDropdown
          activeAlignment={alignment}
          onPick={(newAlignment) => {
            const {
              dispatch,
              state: { tr },
            } = view
            tr.setNodeMarkup(nodePos, undefined, { ...nodeAttrs, float: newAlignment })
            dispatch(tr)
            close()
          }}
        />
      )}
    />
  )
})
